
    <section class="cmn-innerpage-wrapper payment-received">
        <div class="head">
            <div class="search-wrapper">
                <input type="text" class="cmn-header-search" placeholder="Search" (input)="onSearch($event)" />
            </div>
            <!-- <button class="cmn-upload-btn" (click)="openDialog()">
                <img src="assets/images/icons/icon-upload.svg" alt="Upload Icon" />
                <span>Upload</span>
            </button> -->
            <button class="cmn-add-btn" (click)="navigateTo('/payment-received/payment-new')" *ngIf="canCreatePaymentReceived$ | async">
                <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> New Payments
            </button>
            <button class="cmn-filter-btn" (click)="toggleDropdown($event)"
                [ngClass]="{ 'class-clicked': isDropdownOpen }">
                <img src="assets/images/icons/icon-filter.svg" alt="Filter Icon" />
                <span *ngIf="selectedCount > 0">{{ selectedCount }}</span>
            </button>
            <!-- Filter -->
            <div [ngClass]="{ show: isDropdownOpen }" class="common-dropdown filter-position" #dropdown>
                <button class="close-dropdown" (click)="toggleDropdown($event)"></button>
                <form>
                    <h6 class="cmn-popup-heading" (click)="clearFilters()">
                        Filter <span>Clear All</span>
                    </h6>
                    <div class="filter-inner-content">
                        <h2>Payment Mode</h2>
                        <div class="check-wrapper">
                            <div class="check-box" *ngFor="let mode of paymentModeList">
                                <label class="checkbox-wrapper">
                                    <input type="checkbox" [checked]="selectedModes.includes(mode.value)"
                                        (change)="toggleMode(mode.value)" />
                                    {{ mode.label }}
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="btn-wrapper">
                        <button class="cmn-apply-btn" (click)="onApplyFilters()">Apply</button>
                    </div>

                </form>
            </div>
            <!-- Filter -->
        </div>
        <div class="inner-content">
            <ag-grid-angular style="width: 100%;" [rowData]="rowData" [columnDefs]="columnDefs"
                [defaultColDef]="defaultColDef" [rowSelection]="rowSelection" [suppressRowClickSelection]="true"
                [paginationPageSizeSelector]="paginationPageSizeSelector" [class]="themeClass"
                (cellClicked)="onCellClicked($event)" />

            <!-- <button (click)="navigateTo('/payment-received-details')">Details</button> -->
        </div>
        <div class="pagination-wrapper">
            <div class="page-size">
              <label for="pageSize">Page Size:</label>
              <select
                id="pageSize"
                [(ngModel)]="pageSize"
                (change)="onPageSizeChange($event)"
              >
                <option *ngFor="let size of pageSizeOptions" [value]="size">
                  {{ size }}
                </option>
              </select>
            </div>
  
            <!-- Pagination controls using leadStatusData -->
            <div class="page-nav" 
                 *ngIf=" totalPage > 1">
              <button class="prev" (click)="prevPage()" [disabled]="page === 0">
                <img
                  src="../../../assets/images/icons/arrow.svg"
                  alt="prev arrow"
                />
              </button>
              <span>
                Page {{ page + 1 }} of {{totalPage}}
              </span>
              <button
                class="next"
                (click)="nextPage()"
                [disabled]="page + 1 >= totalPage "
              >
                <img
                  src="../../../assets/images/icons/arrow.svg"
                  alt="next arrow"
                />
              </button>
            </div>
          </div>
    </section>
